import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  toggleAllChecks(clickEvent) {
    const sections = this.element.querySelectorAll('.filter-section');
    sections.forEach((section) => {
      let button = section.querySelector('button');
      if (button) {
        button.click();
      }
    });
    if (
      this.element.querySelector('.mdc-button__label').innerHTML ==
      'Uncheck all'
    ) {
      this.element.querySelector('.mdc-button__label').innerHTML = 'Check all';
    } else {
      this.element.querySelector('.mdc-button__label').innerHTML =
        'Uncheck all';
    }
  }

  toggleChecks(clickEvent) {
    if (this.element.dataset.checked == 'true') {
      // uncheck all and set button
      this.element
        .querySelectorAll('input[type=checkbox]')
        .forEach((checkbox) => {
          checkbox.checked = false;
          const event = new Event('change', { bubbles: true });
          checkbox.dispatchEvent(event);
        });
      this.element.querySelector('.mdc-button__label').innerHTML =
        'Check section';
      this.element.dataset.checked = false;
    } else {
      // check all and set button
      this.element
        .querySelectorAll('input[type=checkbox]')
        .forEach((checkbox) => {
          checkbox.checked = true;
          const event = new Event('change', { bubbles: true });
          checkbox.dispatchEvent(event);
        });
      this.element.querySelector('.mdc-button__label').innerHTML =
        'Uncheck section';
      this.element.dataset.checked = true;
    }
  }
}
